// eslint-disable-next-line no-unused-vars
import React from 'react';

const Conditional = props => (
  !!props.if && props.children
);

export default Conditional;
